import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Form, Input, Select, InputNumber, Button, message, Tooltip } from 'antd';
import { getData, postData } from '../../config/api-connect';
import * as Styled from './style.js';
import { Table, Spin } from 'antd';
import Spinner from '../../components/spinner';
import './style.css'
import { useEffect } from 'react';
import { Modal } from 'antd';
import { Dropdown, Menu } from 'antd';
import { MoreOutlined, DoubleLeftOutlined, DeleteOutlined, EyeOutlined, EyeInvisibleOutlined} from '@ant-design/icons'
import { FaAngleDoubleLeft } from "react-icons/fa";
const { Option } = Select;

const EditJob = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const job = location.state?.job;
  const departments = location.state?.departments || [];
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
 useEffect(() => {
    if (job) {
      const deptObj = departments.find(d => d.label === job.department);

      form.setFieldsValue({
        ...job,
        department: deptObj ? deptObj.value : null 
      });
    }
  }, [job, departments, form]);


  const onFinish = (values) => {
    setLoading(true);
    const params = new URLSearchParams({
      id,
      title: values.title,
      location: values.location,
      no_of_openings: values.no_of_openings || ''
    });

    if (values.department !== null && values.department !== undefined && values.department !== '') {
      params.append('department', values.department);
    }

    const payload = { ...values, id };
    postData(`/career/update_job/`,payload)
      .then(() => {
        message.success('Job updated successfully');
        navigate('/careers'); 
      })
      .catch((err) => {
        console.error(err);
        message.error('Failed to update job');
      })
      .finally(() => setLoading(false));
  };

  const handleDelete = () => {
      Modal.confirm({
        title: 'Are you sure you want to delete this job?',
        content: `This will remove "${job?.title}" permanently.`,
        okText: 'Delete',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk: () => {
          setLoading(true);
          getData(`/career/delete_job/?job_id=${job.id}`)
            .then(() => {
              message.success('Job deleted successfully');
              navigate('/careers');
            })
            .catch(err => {
              console.error(err);
              message.error('Failed to delete job');
            })
            .finally(() => setLoading(false));
        }
      });
    };

    const handleToggleStatus = () => {
      const newStatus = job?.status === 1 ? 2 : 1;
      Modal.confirm({
        title: job?.status === 1 ? 'Confirm Unpublish?' : 'Confirm Publish?',
        content: job?.status === 1
          ? `Unpublishing "${job?.title}" will remove it from the careers page.`
          : `Publishing "${job?.title}" will make it visible on the careers page.`,
        okText: job?.status === 1 ? 'Unpublish' : 'Publish',
        cancelText: 'Cancel',
        onOk: () => {
          setLoading(true);
          getData(`/career/toggle_job_status/?job_id=${job.id}&status=${newStatus}`)
            .then(() => {
              message.success(`Job ${newStatus === 1 ? 'published' : 'unpublished'} successfully`);
              navigate('/careers');
            })
            .catch(err => {
              console.error(err);
              message.error('Failed to update status');
            })
            .finally(() => setLoading(false));
        }
      });
    };


  return (
    <Spin spinning={loading} indicator={<Spinner />}>
      <Styled.MainContainer>
        <Styled.Header>
          <Tooltip title="Back"><a style={{cursor: 'pointer',color:'#02475c'}} onClick={()=>navigate(-1)}><FaAngleDoubleLeft/> </a></Tooltip>
          <div>Edit Job {job?.title ? `: ${job.title}` : ''} </div>
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item key="toggle" onClick={handleToggleStatus} icon={job?.status === 1 ? <EyeInvisibleOutlined /> : <EyeOutlined />}>
                  {job?.status === 1 ? 'Unpublish' : 'Publish'}
                </Menu.Item>
                <Menu.Item key="delete" onClick={handleDelete} icon={<DeleteOutlined />} danger>
                  Delete
                </Menu.Item>
              </Menu>
            }
            placement="bottomRight"
            trigger={['click']}
          >
            <MoreOutlined style={{ fontSize: '20px', cursor: 'pointer', color: 'rgb(2, 71, 92)' }} />
          </Dropdown>
        </Styled.Header>
        
        <Styled.FormContainer>
          <Styled.FormBody>
            <Form form={form} layout="vertical" 
                  onFinish={onFinish} initialValues={job} 
                  style={{ width: "100%",maxWidth: "600px",margin: "0 auto",}}>
              <Form.Item
                name="title"
                label="Title"
                rules={[{ required: true, message: 'Please enter title' }]}
              >
                <Input style={{ borderRadius: '4px' }}/>
              </Form.Item>
              <Form.Item
                name="location"
                label="Location"
                rules={[{ required: true, message: 'Please enter location' }]}
              >
                <Input style={{ borderRadius: '4px' }}/>
              </Form.Item>
              <Form.Item
                name="description"
                label="Description"
                rules={[{message: 'Please enter description' }]}
              >
                <Input.TextArea rows={3} style={{ borderRadius: '4px' }} />
              </Form.Item>
              <Form.Item
                name="contact_no"
                label="Contact No"
                rules={[{ required: true, message: 'Please enter contact no' }]}
              >
                <Input style={{ borderRadius: '4px' }}/>
              </Form.Item>
              
              <Form.Item name="department" label="Department">
                <Select placeholder="Select Department" allowClear>
                  {departments.map((dept) => (
                    <Option key={dept.value} value={dept.value}>{dept.label}</Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item name="no_of_openings" label="No of Openings">
                <InputNumber style={{ borderRadius: '4px', width: '100%'}} min={0}/>
              </Form.Item>

              <Form.Item style={{ textAlign: 'center' }}>
                <Button type="primary" htmlType="submit" loading={loading} style={{ borderRadius: '4px', backgroundColor: '#006d77', borderColor: '#3c6e71'  }}>
                  Update
                </Button>
              </Form.Item>
            </Form>
          </Styled.FormBody>
        </Styled.FormContainer>

      </Styled.MainContainer>
    </Spin>
  );
};

export default EditJob;
